import { Component, Vue, Mixins } from 'vue-property-decorator'
import { NoticeDialogBody, NoPhoneErrorDialogBody, TransferConfirmDialogBody } from '@/apps/open/components/DialogBodys/TransferSuperAdmin'
import VerifyPhoneMixin from './VerifyPhone'
import { EVerifyPhoneAction } from '@/apps/open/types'
import AdminSelectorDialogBody from '@/apps/open/components/DialogBodys/AdminSelector.vue'
import { transferSuperAdmin } from '@/apps/open/services/admin'
import { onRequestError } from '@/apps/open/utils'

@Component
export default class TransferSuperAdminMixin extends Mixins(VerifyPhoneMixin) {
  open_ssid = ''
  selectedUser: any = null
  dialogTitle = '转让管理员'

  isShowSelMemberDialog = false

  get isPrivate () {
    return this.$store.getters['isPrivate']
  }

  get curEnterprise () {
    return this.$store.getters['User/curEnterprise']
  }

  onTransfer () {
    this.showNoticeDialog()
  }

  showNoticeDialog () {
    this.$dialog.show({
      title: '转让须知',
      body: NoticeDialogBody,
      buttons: [
        { text: '取消' },
        {
          text: '确定',
          type: 'primary',
          fn: this.isPrivate ? this.switchSelMemberDialog : this.showVerifyPhoneDialog
        }
      ]
    })
  }

  switchSelMemberDialog () {
    this.$dialog.close()
    this.isShowSelMemberDialog = !this.isShowSelMemberDialog
  }

  showVerifyPhoneDialog () {
    this.verifyPhone({
      title: this.dialogTitle,
      action: EVerifyPhoneAction.TRANSFER_SUPER_ADMIN,
      cb: (open_ssid: string) => {
        this.open_ssid = open_ssid
        this.showAdminSelector()
      }
    })
  }

  showAdminSelector () {
    this.$dialog.show({
      title: this.dialogTitle,
      body: AdminSelectorDialogBody,
      bodyProps: {
        filterRoles: [100],
        limit: 1,
        onCancel: this.$dialog.close,
        onOk: this.onSelectUser
      }
    })
  }

  onSelectUser (users: any) {
    this.selectedUser = users[0]
    if (!this.selectedUser.phone) {
      this.$dialog.show({
        title: this.dialogTitle,
        body: NoPhoneErrorDialogBody,
        buttons: [
          { text: '关闭', type: 'primary' }
        ]
      })
      return
    }
    this.$dialog.show({
      title: this.dialogTitle,
      body: TransferConfirmDialogBody,
      bodyProps: {
        selectedUser: this.selectedUser,
        onCancel: this.$dialog.close,
        onOk: this.transfer
      }
    })
  }

  async transfer (private_user: any) {
    try {
      if (this.isPrivate) {
        await transferSuperAdmin(private_user.id, this.curEnterprise.developer_id)
      } else {
        await transferSuperAdmin(this.selectedUser.id, this.curEnterprise.developer_id, this.open_ssid)
      }
      this.$message.success('转让成功')
      this.$store.dispatch('User/LOGOUT')
      this.$dialog.close()
    } catch (error) {
      onRequestError(error, `转让失败（${error.message})`)
    }
  }
}
